/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const CHEVRON_LEFT_PATH =
  'M0.3 7.5L6 13.1C6.4 13.5 7 13.5 7.4 13.1C7.8 12.7 7.8 12.1 7.4 11.7L2.5 6.7L7.4 1.7C7.8 1.3 7.8 0.7 7.4 0.3C7.2 0.0999997 7 0 6.7 0C6.4 0 6.2 0.0999997 6 0.3L0.3 5.9C-0.1 6.4 -0.1 7 0.3 7.5C0.3 7.4 0.3 7.4 0.3 7.5Z';

const CHEVRON_VIEWBOX_W = 8;
const CHEVRON_VIEWBOX_H = 14;

const iconPropTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Chevron-left arrow (8×14). Color via `color` / `stroke`, or CSS on `.ds-icon`
 * (default grey: `--ds-icon-default-color`). Pass `aria-label` when used without adjacent text.
 */
const ChevronLeftIcon = ({
  size = 18,
  color,
  stroke = 'currentColor',
  strokeWidth = 1.5,
  className = '',
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const height = size;
  const width = Math.round((size * CHEVRON_VIEWBOX_W) / CHEVRON_VIEWBOX_H);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${CHEVRON_VIEWBOX_W} ${CHEVRON_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      style={color ? { color, ...style } : style}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={CHEVRON_LEFT_PATH} fill={color || stroke} strokeWidth={strokeWidth} />
    </svg>
  );
};

ChevronLeftIcon.propTypes = iconPropTypes;

export default ChevronLeftIcon;
